export const TIPI_DOCUMENTO = ["PG", "IO", "MOD", "Manuale", "altro"];
export const STATI_DOCUMENTO = ["vigente", "bozza", "obsoleto"];
export const TIPI_SCADENZA = [
  "audit interno",
  "riesame",
  "sorveglianza",
  "rinnovo",
  "aggiornamento legislativo",
  "altro",
];
export const STATI_SCADENZA = ["aperta", "in lavorazione", "chiusa"];

export const ESITI_FORNITORE = ["qualificato", "qualificato con riserva", "non qualificato"];
export const DEFAULT_SUPPLIER_CRITERIA = [
  "Sistema qualità certificato",
  "Referenze / storico positivo",
  "Rispetto tempi di consegna",
  "Conformità requisiti tecnici",
  "Documentazione / DURC in regola",
  "Gestione reclami adeguata",
];
export const TIPI_INCIDENTE = ["near-miss", "incidente", "infortunio"];
export const GRAVITA_INCIDENTE = ["lieve", "media", "grave"];
export const STATI_OBIETTIVO = ["aperto", "raggiunto", "non raggiunto"];

// Scheda Attività Formativa (MOD ISO)
export const TIPI_ATTIVITA_FORMATIVA = [
  "Formazione (Art. 37)",
  "Informazione (Art. 36)",
  "Aggiornamento",
  "Addestramento",
  "Affiancamento",
  "NC / Richiamo",
];
export const DESTINATARI_FORMAZIONE = ["Operativi", "Responsabili di funzione"];
export const METODI_VERIFICA_EFFICACIA = ["Colloquio", "Test scritto", "Test di campo"];
export const ESITI_VERIFICA = ["SI", "NO", "VNC"];
export const RIFERIMENTI_TIPO = ["interno", "esterno"];

export const STATO_BADGE = {
  vigente: "bg-blue-100 text-blue-800 border-blue-200",
  bozza: "bg-amber-100 text-amber-800 border-amber-200",
  obsoleto: "bg-slate-100 text-slate-600 border-slate-200",
};
